import { pdfjs } from 'react-pdf';
import { canvasToBlob } from '@/utils/dom';
import { PREVIEW_SIZE } from '@/utils/images';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export async function createPdfPreview(blob: Blob) {
  const arrayBuffer = await blob.arrayBuffer();

  const pdfDoc = await pdfjs.getDocument({ data: arrayBuffer }).promise;
  const page = await pdfDoc.getPage(1);

  const viewport = page.getViewport({ scale: 1 });

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Unable to create canvas context for PDF preview');
  }

  // Scale to fit in a `PREVIEW_SIZE` square
  const scale = Math.min(
    PREVIEW_SIZE / viewport.width,
    PREVIEW_SIZE / viewport.height
  );
  const scaledViewport = page.getViewport({ scale });

  canvas.width = PREVIEW_SIZE;
  canvas.height = PREVIEW_SIZE;

  const offsetX = (PREVIEW_SIZE - scaledViewport.width) / 2;
  const offsetY = (PREVIEW_SIZE - scaledViewport.height) / 2;

  await page.render({
    canvasContext: context,
    viewport: scaledViewport,
    transform: [1, 0, 0, 1, offsetX, offsetY], // Center the page in the canvas
  }).promise;

  return canvasToBlob(canvas);
}
